import React, { useContext } from "react";
import LoginForm from "./login.form";
import { Link } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import { IFirebaseAuthUser } from "../../interfaces/authentication.interfaces";
import withAuthorization from "../HOC/with.authorization";
import AuthenticationValidatorLogic from "../../logic/authenticationValidatorLogic";
import EventImage from "../../assets/landing_page.jpg";
import { PublicPageWithForm } from "../PublicPageWithForm/publicPageWithForm";
import AppContext from "../../context/app.context";
import { env } from "../../env";

const SignInPage = () => {
	const appContext = useContext(AppContext);
	return (
		<PublicPageWithForm imageSource={EventImage}>
			<LoginForm userService={appContext.services.userService} />
		</PublicPageWithForm>
	);
};

export const LoginLink = () => (
	<>
		<p>
			Already got an account?{" "}
			<Link to={ROUTES.SIGN_IN.route}>{ROUTES.SIGN_IN.label}</Link>
		</p>
		<p>
			<a href={ROUTES.IMPRINT.route} target="_blank">
				Imprint
			</a>
		</p>
	</>
);

// A valid demo redirect_key must always reach LoginForm's auto-login effect,
// even if a stale session for a different account is already active in this
// browser - otherwise whoever was last logged in here just gets bounced
// straight to /map instead of switching to the demo account.
const hasDemoRedirectKey = () => {
	const { redirect_key } = Object.fromEntries(
		new URLSearchParams(window.location.search)
	);
	return (
		!!redirect_key &&
		(redirect_key === env.REACT_APP_SVX_REDIRECT_KEY ||
			redirect_key === env.REACT_APP_LIA_REDIRECT_KEY)
	);
};

const condition = (authUser: IFirebaseAuthUser) =>
	!AuthenticationValidatorLogic.isAuthenticated(authUser) || hasDemoRedirectKey();
export default withAuthorization(condition)(ROUTES.MAP.route)(SignInPage);
